var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCannabis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12591_10858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2106 0C10.6599 0.859632 11.2053 1.66837 11.6513 2.53132C12.4933 4.16097 13.7387 6.80514 13.6213 8.65164C13.4826 10.8267 11.8925 12.4918 10.0538 13.3204C8.84252 12.8414 7.67823 12.0448 7.01765 10.8544C5.02416 7.26207 8.13605 2.79463 10.2106 0Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 5.28834C18.7277 9.65399 16.9455 15.9646 11.1699 13.6579C12.3171 12.7584 13.4537 11.7926 13.9873 10.3521C14.4899 8.99571 14.3341 7.80528 14.1612 6.40132C16.0491 5.77402 18.0276 5.47863 19.9987 5.28723L19.9998 5.28834Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84707 6.39689C5.03388 9.43271 6.36999 12.0437 8.82984 13.659C3.05853 15.9779 1.23473 9.66504 0 5.28833C1.97642 5.46424 3.94536 5.81385 5.84707 6.39578V6.39689Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82963 14.4323C6.90444 17.3486 3.09675 15.4568 0.53125 14.6502L2.28676 12.7805C3.92701 14.8461 6.43382 15.355 8.82963 14.4323Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4685 14.6503C16.9884 15.4059 13.1327 17.3254 11.2769 14.5429C13.5756 15.2068 16.1549 14.9191 17.6084 12.7783L19.4685 14.6514V14.6503Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12591_10858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannabis);
export default __webpack_public_path__ + "static/media/Cannabis.938548ed2bad0140da7e4be0b457a8ca.svg";
export { ForwardRef as ReactComponent };